import { INIT_STATE, CACHE_VALUES, RESULT } from '../types/types';

const initState = {
    calc_button: '',
    currency: '',
    fields: [],
    form_button: '',
    result_title: '',
    cacheResetter: {},
    cacheOptions: {},
    cacheValue: {},
    validation: {},
    automaticCalculation: [{
        "result": "auto_loan_amount",
        "args": [
            "auto_car_price",
            "auto_down_payment"
        ],
        "method": "minus"
    }],
    relatedInputs: {},
    result: {}
}


const mainReducer = (state = initState, actions) => {
    switch (actions.type) {
        case INIT_STATE:
            return {
                cacheResetter: {},
                cacheOptions: {},
                cacheValue: {},
                validation: {},
                automaticCalculation: [{
                    "result": "auto_loan_amount",
                    "args": [
                        "auto_car_price",
                        "auto_down_payment"
                    ],
                    "method": "minus"
                }],
                relatedInputs: {},
                ...actions.payload
            };
        case CACHE_VALUES:
            return {
                ...state,
                cacheValue: actions.payload,
            }
        case RESULT:
            return {
                ...state,
                result: actions.payload
            }
        default:
            return state;
    }
}
export default mainReducer;
